module.exports = __webpack_public_path__ + "static/8-9ee4698502762af16fb6ed682803c0f4.jpg";